import React from "react";
import { Link, Outlet } from "react-router-dom";
import MainChallans from "./MainChallans";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
const ShowingChallans = () => {
  const navigate = useNavigate();
  const Mainchallansbtn = () => {
    console.log("chalans");
    navigate("/dashbaord/mainchallans");
  };
  const Localchallansbtn = () => {
    console.log("chalans");
    navigate("/dashbaord/localchallans");
  };

  const Ewaybtn = () => {
    console.log("chalans");
    navigate("/dashbaord/ewayforms");
  };

  const Bilties = () => {
    console.log("Bilties");
    navigate("/dashbaord/bilties");
  };
  return (
    <div style={{ margin: "auto", textAlign: "center" }}>
      <Button
        style={{
          border: "2px solid #ccc",
          fontSize: "18px",
          padding: "8px 16px",
        }}
        onClick={() => Mainchallansbtn()}
        className="dBtn"
      >
        {" "}
        Challans
      </Button>

      <Button
        style={{
          marginLeft: "10px",
          border: "2px solid #ccc",
          fontSize: "18px",
          padding: "8px 16px",
        }}
        onClick={() => {
          Localchallansbtn();
        }}
        className="dBtn"
      >
        {" "}
        Freight Challans
      </Button>

      <Button
        style={{
          marginLeft: "10px",
          border: "2px solid #ccc",
          fontSize: "18px",
          padding: "8px 16px",
        }}
        onClick={() => {
          Ewaybtn();
        }}
        className="dBtn"
      >
        {" "}
        Ewayforms
      </Button>

      <Button
        style={{
          marginLeft: "10px",
          border: "2px solid #ccc",
          fontSize: "18px",
          padding: "8px 16px",
        }}
        onClick={() => {
          Bilties();
        }}
        className="dBtn"
      >
        Bilty
      </Button>
    </div>
  );
};

export default ShowingChallans;
